import React, { useMemo } from 'react';
import { ProfileCardClientConfigContext } from '@atlassian/people-teams-ui/profile-client-config';
import { useProfileClient } from '../index';
export function ProfileCardClientConfigProvider({
  children,
  ...props
}) {
  const profileCardClient = useProfileClient();
  const config = useMemo(() => ({
    ...props,
    profileCardClient
  }), [props, profileCardClient]);
  return /*#__PURE__*/React.createElement(ProfileCardClientConfigContext.Provider, {
    value: config
  }, children);
}